import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'hedou-header-mobile',
	templateUrl: './header-mobile.component.html',
	styleUrls: ['./header-mobile.component.less']
})
export class HeaderMobileComponent implements OnInit {

	headerLogo = '';
	asideSelfDisplay = true;
	headerMenuSelfDisplay = true;
	headerMobileClasses = '';
	headerMobileAttributes = {};
	constructor() { }

	ngOnInit(): void {
	}

}
